import { supabase } from "@/lib/supabase/supabaseClient";
import { UpdateCrmConfigProps } from ".";

export const updateCrmConfig = async (data: UpdateCrmConfigProps) => {
    const { id, ...dataWithoutId } = data;
    return await supabase.from("crm_config").update(dataWithoutId).eq("id", id!);
}